import { ExternalVendorIcons } from 'components/ExternalVendorIcons/ExternalVendorIcons'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TIrrigationZoneEmitterId, TPropertyId } from 'stores/fieldAssetStore/helperTypes'
import { getIrrigationZoneEmitterExternalVendorNames } from 'utils/getIrrigationZoneEmitterExternalVendorNames'

export const ZoneVendorIcons = ({
  propertyId,
  irrigationZoneEmitterId,
}: {
  propertyId: TPropertyId
  irrigationZoneEmitterId: TIrrigationZoneEmitterId
}) => {
  const externalVendorNames = fieldAssetStore.useSelector((s) => {
    const property = s.properties?.[propertyId]
    const irrigationZoneEmitter = property?.irrigationZoneEmitters?.[irrigationZoneEmitterId]

    if (!property || !irrigationZoneEmitter) return []

    return getIrrigationZoneEmitterExternalVendorNames({
      irrigationZoneEmitter,
      points: Object.values(property.points ?? {}),
    })
  })

  if (!externalVendorNames.length) return null

  return <ExternalVendorIcons externalVendorNames={externalVendorNames} size={20} />
}
